export default __webpack_public_path__ + "static/media/stomach_plot_female.8d9ad506.png";